import { create } from "zustand";
import { useSessionStore } from "./Session";

export type StatusPageResource = {
  id: string;
  name: string;
  resourceType: string;
  status: string | null;
  availability?: number | null;
};

export type StatusPageReport = {
  title: string;
  reportType: string;
  startsAt: string | null;
  endsAt: string | null;
  aggregateState: string;
  affectedResources: any[];
};

interface StatusPageState {
  statusPageName: string;
  statusPageUrl: string;
  aggregateState: string;
  resources: StatusPageResource[];
  activeReports: StatusPageReport[];
  lastSyncedAt: string | null;
  loadingStatus: boolean;
  loadStatusPage: () => void;
}

export const useStatusPageStore = create<StatusPageState>()((set, get) => ({
  statusPageName: "",
  statusPageUrl: "",
  aggregateState: "operational",
  resources: [],
  activeReports: [],
  lastSyncedAt: null,
  loadingStatus: false,
  loadStatusPage() {
    const sessionStore = useSessionStore.getState();

    if (get().loadingStatus) {
      return;
    }

    set({ loadingStatus: true });

    var xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      sessionStore.apiUrl + "/config/" + sessionStore.sdkKey + "/status"
    );
    xhr.setRequestHeader("Api-Token", sessionStore.sdkKey);

    if (sessionStore.session) {
      xhr.setRequestHeader("Gleap-Id", sessionStore.session.gleapId ?? "");
      xhr.setRequestHeader("Gleap-Hash", sessionStore.session.gleapHash ?? "");
    }

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200 && xhr.responseText) {
        try {
          const data = JSON.parse(xhr.responseText);
          if (data) {
            set({
              statusPageName: data.statusPageName || "",
              statusPageUrl: data.statusPageUrl || "",
              aggregateState: data.aggregateState || "operational",
              resources: data.resources || [],
              activeReports: data.activeReports || [],
              lastSyncedAt: data.lastSyncedAt || null,
              loadingStatus: false,
            });
          }
        } catch (exp) {
          set({ loadingStatus: false });
        }
      } else if (xhr.readyState == 4) {
        set({ loadingStatus: false });
      }
    };

    xhr.send();
  },
}));
